var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8452 6.84518C12.1943 7.49605 11.139 7.49605 10.4882 6.84518C9.83728 6.1943 9.83728 5.13903 10.4882 4.48816C11.139 3.83728 12.1943 3.83728 12.8452 4.48816C13.4961 5.13903 13.4961 6.1943 12.8452 6.84518Z",
    stroke: "#151928",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47018 1.99906C8.16761 1.30163 9.13089 0.939691 10.1072 1.00823L13.4108 1.24017C15.0603 1.35598 16.3628 2.65848 16.4787 4.30803L16.7106 7.61163C16.7791 8.58793 16.4172 9.55121 15.7198 10.2486L10.2486 15.7198C8.92918 17.0392 6.80428 17.0536 5.50253 15.7518L1.967 12.2163C0.665252 10.9145 0.679603 8.78964 1.99905 7.47019L7.47018 1.99906Z",
    stroke: "#151928",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIconBlack);
export default __webpack_public_path__ + "static/media/tag-icon-black.6f8234a44d7f43c11e0a05e623ada8fb.svg";
export { ForwardRef as ReactComponent };